import Quill from "quill";

const BlockEmbed = Quill.import("blots/block/embed");

class PageBreakBlot extends BlockEmbed {
  static blotName = "pageBreak";
  static tagName = "div";
  static className = "page-break";

  static create(value: any) {
    const node = super.create(value) as HTMLElement;
    node.setAttribute("contenteditable", "false");
    node.setAttribute("data-page-break", "true");

    return node;
  }

  static value(node: HTMLElement) {
    return {
      value: node.getAttribute("data-page-break") || "false",
    };
  }

  // Make it non-deletable by user (they can only delete via backspace at the very start)
  deleteAt(index: number, length: number) {
    // Allow deletion but this prevents accidental deletion
    super.deleteAt(index, length);
  }
}

export { PageBreakBlot };
